import {
    Subject
} from 'one-state-subject/src/Subject';
import { diff, format } from 'one-util-date';
import {
    EmergencyDetails
} from 'one-state-subject';
import {
    EmployerDetails
} from 'one-state-subject';

// ADPAC-316
function sortFunction(a: Subject, b: Subject) {
    const nameA = a.lastname.toLowerCase();
    const nameB = b.lastname.toLowerCase();
    return (nameA > nameB) ? 1 : -1;

}
const checkAge = (dob: any) => {
    let age = "";
    if (dob !== undefined && dob !== null && dob !== "") {
        age = diff(dob).toString();
    }
    return age;
}

export const formatPhoneNumber = (phoneNumberString: any) => {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    if (cleaned.length == 10) {
        return '(' + cleaned.substring(0, 3) + ') ' + cleaned.substring(3, 6) + '-' + cleaned.substring(6, 10);
    }
    return "";
}
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * upcoming Appointments Component
 * @param response has the backend upcoming
 * appointment response
 * @param context has settings etc..
 */
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    const result: Subject[] = [];

    let subjectresult: any = {
        subjectdata: result,
        error: undefined

    }
    const { log, settings: { epicendpoints, uisettings: { dateformat, prescription_mrn: { mrn_value } } } } = context;
    log.debug("one-epic", "transformation entered", response);
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        subjectresult.error = response;
    }
    //ADPAC-348
    else if (response && response.length > 0) {
        const rs = response;
        rs.map((ele: any) => {
            let source: Subject = {
                initials: "",
                id: "",
                middlename: "",
                mrn: "",
                dob: "",
                gender: "",
                age: "",
                contact: "",
                contact_formatted: "",
                address: "",
                lastname: "",
                firstname: "",
                name: "",
                race: "",
                email: "",
                ssn: "",
                zipcode: "",
                prescriptionMRNData: "",
                emergencycontact: [],
                employmentinfo: []
            }
            if (ele.PatientID) {
                const id = ele.PatientID.filter((object: any) => object.Type === epicendpoints.searchID)
                const prescription_MRNValue = ele.PatientID.filter((mrninfo: any) => mrninfo.Type === mrn_value)
                if (id.length) {
                    source.initials = ele.LastName?.charAt(0) + ele.FirstName?.charAt(0)
                    source.id = id[0].ID;
                    source.mrn = id[0].ID;
                    source.prescriptionMRNData = prescription_MRNValue.length ? prescription_MRNValue[0].ID : "";
                    source.firstname = ele.FirstName;
                    source.lastname = ele.LastName;
                    source.name = ele.Name;
                    source.dob = ele.DateOfBirth ? format(ele.DateOfBirth, dateformat) : "";
                    const age = checkAge(ele.DateOfBirth);
                    source.age = age ? age : "";
                    //source.age = age ? age + " year old " + ele?.Sex : "";
                    source.gender = ele.Sex;
                    source.race = ele.Race;
                    source.ssn = ele.NationalIdentifier;
                    let addrstr = "";
                    let phone = "";
                    let phoneNumbers: any = []
                    let email = "";
                    let emergencydata: EmergencyDetails[] = [];
                    let employerinfo: EmployerDetails[] = [];
                    if (ele.Addresses) {
                        ele.Addresses.map((address: any) => {
                            if (address?.Type === "Permanent") {
                                addrstr = addrstr.concat(address.Street[0] ? address.Street[0] + "," : "");
                                addrstr = addrstr.concat(address.City ? address.City + "," : "");
                                addrstr = addrstr.concat(address.State ? address.State + "," : "");
                                // addrstr = addrstr.concat(address?.Country ? address?.Country + "," : "");
                                addrstr = addrstr.concat(address.PostalCode ? address.PostalCode : "");
                                address.PhoneNumbers.map((phoneobj: any) => {
                                    if (phoneobj?.Type === 'Home Phone') {
                                        phone = phoneobj.Number
                                    }
                                })
                                phoneNumbers = address.PhoneNumbers
                                address.Email.map((emailid: any) => {
                                    email = emailid;
                                })
                                source.zipcode = address.PostalCode;
                            }
                        })
                    }
                    if (ele.EmergencyContacts) {
                        ele.EmergencyContacts.map((emerge: any) => {
                            let info = {
                                emergename: emerge?.Name ? emerge.Name : "",
                                contactrelation: emerge?.Relation ? emerge.Relation : "",
                                contactnumber: ""
                            }
                            emergencydata.push(info)
                            emerge?.PhoneNumbers.forEach((contactdata: any) => {
                                if (contactdata?.Type === "Home Phone") {
                                    info.contactnumber = contactdata.Number
                                }
                            });
                        })

                    }
                    if (ele.EmploymentInformation) {

                        ele.EmploymentInformation.map((emerge: any) => {
                            let info = {
                                employername: emerge?.EmployerName ? emerge.EmployerName : "",
                                occupation: emerge?.Occupation ? emerge.Occupation : "",
                                contactnumber: ""
                            }
                            employerinfo.push(info)
                            emerge?.PhoneNumbers.forEach((contactdata: any) => {
                                if (contactdata) {
                                    info.contactnumber = contactdata.Number
                                }
                            });
                        })
                    }
                    source.address = addrstr;
                    source.contact = phone;
                    const formatednumber = formatPhoneNumber(phone);
                    source.phoneNumbers = phoneNumbers;
                    source.contact_formatted = formatednumber === "" ? phone : formatednumber;
                    source.email = email;
                    source.emergencycontact = emergencydata;
                    source.employmentinfo = employerinfo;
                }
            }
            result.push(source);
        })
    }
    // ADPAC-316
    result.sort(sortFunction);
    subjectresult.subjectdata = result;
    return subjectresult;
}



